export default "__VITE_ASSET__CfdpJQNb__"